import React, { Fragment } from 'react';
import classnames from 'classnames';
import Accordion from 'components/molecules/Accordion';
import CategoryLink from 'components/atoms/CategoryLink';

import styles from './index.css';

const CategoryAccordion = ({
	className,
	categoryList,
	activeId,
	isNavi = false,
	closeMenu = () => {},
}) => (
	<div className={classnames(styles.categoryAccordion, className)}>
		{categoryList.map(item =>
			item.children.length > 0 ? (
				<Accordion
					key={item.id}
					headClassName={classnames(styles.itemLevel1, styles.accordion, {
						[styles.red]: item.red,
						[styles.active]: item.id === activeId,
						[styles.isNavi]: isNavi,
					})}
					contentClassName={styles.content}
					defaultHeight={isNavi ? 62 : 42}
					title={item.name}
					titleUrl={item.disableLink ? undefined : `/product?category_id=${item.id}`}
					onClickTitle={closeMenu}
				>
					{item.children.map(children => (
						<Fragment key={children.id}>
							<CategoryLink
								className={classnames(styles.itemLevel2, {
									[styles.active]: children.id === activeId,
									[styles.isNavi]: isNavi,
								})}
								item={children}
								onClick={closeMenu}
							>
								{children.name}
							</CategoryLink>
							{children.children && (
								<div className={styles.subContentWrapper}>
									{children.children.map(subItem => (
										<CategoryLink
											key={subItem.id}
											className={classnames(styles.itemLevel3, {
												[styles.active]: subItem.id === activeId,
												[styles.isNavi]: isNavi,
											})}
											item={subItem}
											onClick={closeMenu}
										>
											{subItem.name}
										</CategoryLink>
									))}
								</div>
							)}
						</Fragment>
					))}
				</Accordion>
			) : (
				<CategoryLink
					key={item.id}
					className={classnames(styles.itemLevel1, styles.singleItem, {
						[styles.red]: item.red,
						[styles.active]: item.id === activeId,
						[styles.isNavi]: isNavi,
					})}
					item={item}
					onClick={closeMenu}
				>
					{item.name}
				</CategoryLink>
			),
		)}
	</div>
);

export default CategoryAccordion;
